export default class Signature {
    value;
    keyId;
    method;
    constructor(value, keyId, method) {
        this.value = value;
        this.keyId = keyId;
        this.method = method;
    }
}
//# sourceMappingURL=Signature.js.map